import {
  CommitmentStatuses,
  CommitmentTypes,
} from 'legacy/lut/components/widgets/public/partner360/commitment/models'
import type { ICommitmentData } from 'legacy/lut/services/partner360/commitment/models/apiCommitmentData'

const isSameValue = (a: string, b: string) => a.trim() === b.trim()

/** A PBM has signed a plan of the partner, any offering of the year the data holds. A signature
 *  dropped by a change of the plan waits to be signed again, so it does not count. */
export const hasPbmSignature = (commitments: ICommitmentData[], partnerId: string) =>
  commitments.some(
    (item) =>
      isSameValue(item.PartnerId, partnerId) &&
      item.CommitmentType === CommitmentTypes.PBM &&
      item.IsAcknowledged === 1 &&
      !((item.Dropped ?? 0) > 0) &&
      item.CommitmentStatusKey !== CommitmentStatuses.Dropped
  )
